import _axios from '@/plugins/axios';
import { CCMError } from '../../../lib/Errors';

export default {
  async getCCMMedicationEventByPatientId (patientId) {
    const response = await _axios.get(
      `/ccmmedicationevent/getbypatientid/${patientId}`,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM medication event by patient ID');
  },
  async getCCMMedicationEventByCCMRecordId (ccmRecordId) {
    try {
      const response = await _axios.get(
        `/ccmmedicationevent/getbyccmrecordid/${ccmRecordId}`,
      );
      if (response.data.resFlag) {
        return response.data;
      }
      throw new CCMError('Error getting CCM condition by CCM record ID');
    } catch (error) {
      if (error.response && error.response.status === 401) {
        return [];
      }
      throw new CCMError('Error getting CCM condition by CCM record ID', error);
    }
  },
  async getCCMMedicationEvent (id) {
    const response = await _axios.get(`/ccmmedicationevent/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error getting CCM condition');
  },
  async addCCMMedicationEvent (body) {
    const response = await _axios.post('/ccmmedicationevent', body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error adding CCM condition');
  },
  async updateCCMMedicationEvent (id, body) {
    const response = await _axios.put(`/ccmmedicationevent/${id}`, body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error updating CCM condition');
  },
  async deleteCCMMedicationEvent (id) {
    const response = await _axios.delete(`/ccmmedicationevent/${id}`);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new CCMError('Error deleting CCM condition');
  },
};
